export class OrderSimDataCustomerEntity {
  name?: string;
  phone?: string;
  email?: string;
  address?: string;

  constructor(data?: Partial<OrderSimDataCustomerEntity>) {
    Object.assign(this, data);
  }
}

export class OrderSimDataRequestEntity {
  transRef?: string;
  packageCode?: string;
  simType?: number;
  phoneNumberCode?: string;
  invoice?: boolean;
  customer?: OrderSimDataCustomerEntity;

  constructor(data?: Partial<OrderSimDataRequestEntity>) {
    Object.assign(this, data);
  }
}

export class OrderSimDataHeaderEntity {
  partnerKey?: string;
  signature?: string;

  constructor(data?: Partial<OrderSimDataHeaderEntity>) {
    this.partnerKey = data?.partnerKey;
    this.signature = data?.signature;
  }
}
